// Narrows member pharmacy lists to the parent companies a GCT user has picked while
// "Decompose Groups into Parent Companies" is on.
//
// The selection lives on the UserContext as selectedRpidsForGroup. It refines the selected Group
// rather than replacing it, so the locations the server returns still cover the whole Group and
// the narrowing happens here, on the client.
//
// Two shapes need filtering: the dropdown options built by LocationOptionHelpers, which carry the
// parent company on an rpid property, and the raw GetUserLocationsDetails rows, which carry it on
// memberRpid.

// RPIDs arrive as two different types and must be compared as strings.
//
// selectedRpidsForGroup holds organization option values, which the server stringifies
// (ItemId = pc.MrpRpid.ToString()), while rpid and memberRpid come off the locations payload as
// numbers. Comparing them directly would match nothing, and because an empty match falls back to
// the full list that failure would look like the option quietly doing nothing at all.
function ToRpidKey(rpid) {
  return rpid === null || rpid === undefined ? "" : String(rpid);
}

function ToSelectedRpidKeys(selectedRpids) {
  if (!Array.isArray(selectedRpids) || selectedRpids.length < 1) {
    return null;
  }

  return new Set(selectedRpids.map(ToRpidKey));
}

/**
 * Filters a list to the entries whose RPID is in the selection.
 *
 * Returns the list untouched when there is no selection, and also when the selection matches
 * nothing. A Group always resolves to all of its members, so an empty result would mean "no data"
 * rather than "the whole Group", which is never what the user asked for. This mirrors the
 * fall-back ReconcileSelectedRpids already applies to the selection itself.
 */
function FilterByRpids(items, selectedRpids, getRpid) {
  if (!Array.isArray(items) || items.length < 1) {
    return items;
  }

  const selectedKeys = ToSelectedRpidKeys(selectedRpids);

  if (selectedKeys === null) {
    return items;
  }

  const filtered = items.filter((item) =>
    selectedKeys.has(ToRpidKey(getRpid(item)))
  );

  return filtered.length > 0 ? filtered : items;
}

// For the dropdown options produced by LocationOptionHelpers.
export function FilterOptionsBySelectedRpids(options, selectedRpids) {
  return FilterByRpids(options, selectedRpids, (option) => option.rpid);
}

// For the raw GetUserLocationsDetails rows (UserProgramRecordLocation).
export function FilterLocationDetailsBySelectedRpids(details, selectedRpids) {
  return FilterByRpids(details, selectedRpids, (detail) => detail.memberRpid);
}
